import {mergeGraph, registerGraph} from '@/angular/modules/vrm-graph/config-utils';


registerGraph('usageGraph', usageGraph);

/* @ngInject */
function usageGraph(GraphService, EssGraphService, locale, defaultGraph, nowIndicatorConfig) {
    const GraphColors = GraphService.colors;

    return mergeGraph(defaultGraph(), nowIndicatorConfig(), {
            size: {
                height: null // fix to make it scale to container height
            },
            options: {
                chart: {
                    plotBackgroundColor: '#f0efeb',
                    marginBottom: 70, // to make space for longer time labels i.e. '17. Aug 02:00'
                    marginLeft: 48, // to have the width of the left axis panel fixed
                },
                plotOptions: {
                    column: {
                        pointPadding: 0.05,
                        groupPadding: 0,
                        borderWidth: 1,
                        borderColor: 'rgba(0,0,0,0)',
                        grouping: true,
                        crisp: false,
                        pointPlacement: 'on',
                        stacking: 'normal'
                    }
                },
                tooltip: EssGraphService.getTooltipFormatter(GraphService, 'kWh')
            },
            chart: {
                type: 'column',
                styledMode: true
            },
            xAxis: {
                type: 'datetime',
                labels: {formatter: GraphService.datetimeLabeler()},
                startOfWeek: 1,
                tickInterval: 1000 * 60 * 60,
                offset: 0,
                lineWidth: 0,
                minPadding: 0,
                maxPadding: 0,
                plotLines: [
                    {
                        color:  GraphService.colors.lightGrey,
                        value: null,
                        width: 1,
                        zIndex: 4
                    }
                ]
            },
            yAxis: [
                {
                    title: {
                        text: locale.getString('graph.usage'),
                        align: 'high',
                        y: -30,
                        rotation: 0,
                        offset: 0
                    },
                    plotLines: [
                        {
                            color:  GraphService.colors.lightGrey,
                            value: 0,
                            width: 1,
                        }
                    ],
                    gridLineWidth: 0,
                    visible: true,
                    showFirstLabel: true,
                    labels: {
                        formatter: function() {
                            return Math.abs(this.value);
                        }
                    }
                },
            ],
            series: [
                {
                    name: locale.getString('graph.grid_usage'),
                    type: "column",
                    pointPlacement: "between",
                    stack: "grid",
                    color: EssGraphService.getColumnColor(EssGraphService.colors.RED),
                    borderColor: EssGraphService.getColumnColor(EssGraphService.colors.RED),
                    id: "grid_usage",
                    visible: false,
                    data: []
                },
                {
                    name: locale.getString('graph.battery_usage'),
                    type: "column",
                    pointPlacement: "between",
                    color: EssGraphService.getColumnColor(EssGraphService.colors.BLUE),
                    borderColor: EssGraphService.getColumnColor(EssGraphService.colors.BLUE),
                    stack: "battery",
                    id: "battery_usage",
                    visible: false,
                    data: []
                },
                {
                    name: locale.getString('graph.grid_usage_fc'),
                    type: "column",
                    pointPlacement: "between",
                    stack: "grid",
                    color: EssGraphService.getColumnColor(EssGraphService.colors.RED, true),
                    borderColor: EssGraphService.getColumnColor(EssGraphService.colors.RED),
                    id: "grid_usage_fc",
                    visible: false,
                    data: []
                },
                {
                    name:locale.getString('graph.battery_usage_fc'),
                    type: "column",
                    pointPlacement: "between",
                    stack: "battery",
                    color: EssGraphService.getColumnColor(EssGraphService.colors.BLUE, true),
                    borderColor: EssGraphService.getColumnColor(EssGraphService.colors.BLUE),
                    id: "battery_usage_fc",
                    visible: false,
                    data: []
                }
            ]
        }
    );
}
